let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eqZfY")).then(() => parcelRequire('hIg1y'));